export default __webpack_public_path__ + "static/media/property_168.ebc7a477.png";